import { useMemo } from "react";
import {
  QuestionnaireLoadingState,
  QuestionnaireLoadingReason,
  MutationsObject,
  QueriesObject,
} from "../context/QuestionnaireContext";

export const useQuestionnaireLoadingState = (
  queries: QueriesObject,
  mutations: MutationsObject,
): QuestionnaireLoadingState => {
  return useMemo((): QuestionnaireLoadingState => {
    const { isFetching, isLoading } = queries.questionnaireQuery;

    const loadingStates: {
      condition: boolean;
      reason: QuestionnaireLoadingReason;
    }[] = [
      { condition: isFetching || isLoading, reason: "loading_data" },
      {
        condition: mutations.submitQuestionnaireMutation.isPending,
        reason: "submitting_form",
      },
      {
        condition: mutations.submitStatementsMutation.isPending,
        reason: "submitting_form",
      },
      {
        condition: mutations.acceptAgreementMutation.isPending,
        reason: "accepting_agreement",
      },
      {
        condition: mutations.cancelAgreementMutation.isPending,
        reason: "rejecting_agreement",
      },
    ];

    const activeState = loadingStates.find((state) => state.condition);
    return activeState
      ? { isLoading: true, reason: activeState.reason }
      : { isLoading: false };
  }, [
    queries.questionnaireQuery,
    mutations.submitQuestionnaireMutation.isPending,
    mutations.submitStatementsMutation.isPending,
    mutations.acceptAgreementMutation.isPending,
    mutations.cancelAgreementMutation.isPending,
  ]);
};
